import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../services/user.service';

/**
 * Component for viewing workflow batch properties.
 */
@Component({
	selector: 'workflow-batch-properties',
	templateUrl: './batch-properties.component.html',
	styleUrl: './batch-properties.component.css'
})
export class BatchPropertiesComponent implements OnInit {
	@Input() batch: any;

	LOCALIZATION: any;

	constructor(
		private modalService: NgbActiveModal,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}
	
	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
